import { render, staticRenderFns } from "./countDown.vue?vue&type=template&id=2c4bba65&scoped=true&"
import script from "./countDown.vue?vue&type=script&lang=js&"
export * from "./countDown.vue?vue&type=script&lang=js&"
import style0 from "./countDown.vue?vue&type=style&index=0&id=2c4bba65&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4bba65",
  null
  
)

export default component.exports